import type { BootstrapResponse } from "../shared/contracts";

export const previewFixture: BootstrapResponse = {
  context: {
    hospital: {
      id: "hospital-demo-lys",
      code: "LYS-DEMO",
      name: "LYS OrthoOS 가상 정형외과",
      timezone: "Asia/Seoul",
    },
    user: {
      id: "user-demo-doctor",
      displayName: "가상 이윤석 원장",
      role: "doctor",
    },
    database: {
      environment: "preview",
      dataClassification: "synthetic_only",
    },
    mode: "demo",
  },
  waiting: [
    {
      receptionId: "reception-demo-chair-003",
      encounterId: "encounter-demo-chair-003",
      patientId: "patient-demo-chair-003",
      chartNumber: "CHAIR-0003",
      patientName: "가상 신환 003",
      sexAtBirth: "unknown",
      dateOfBirth: "1980-01-01",
      reason: "",
      receptionStatus: "waiting",
      encounterStatus: "planned",
      flowStage: "waiting",
      arrivedAt: "2026-08-04T23:25:00.000Z",
    },
    {
      receptionId: "reception-demo-shoulder",
      encounterId: "encounter-demo-shoulder",
      patientId: "patient-demo-shoulder",
      chartNumber: "DEMO-1001",
      patientName: "가상 김정호",
      sexAtBirth: "male",
      dateOfBirth: "1968-08-01",
      reason: "우측 어깨 통증",
      receptionStatus: "waiting",
      encounterStatus: "planned",
      flowStage: "waiting",
      arrivedAt: "2026-07-31T12:10:00.000Z",
    },
    {
      receptionId: "reception-demo-pre-test",
      encounterId: "encounter-demo-pre-test",
      patientId: "patient-demo-pre-test",
      chartNumber: "DEMO-1002",
      patientName: "가상 박서연",
      sexAtBirth: "female",
      dateOfBirth: "1975-04-11",
      reason: "좌측 무릎 통증",
      receptionStatus: "called",
      encounterStatus: "in_progress",
      flowStage: "pre_test",
      arrivedAt: "2026-08-01T06:40:00.000Z",
    },
    {
      receptionId: "reception-demo-testing",
      encounterId: "encounter-demo-testing",
      patientId: "patient-demo-testing",
      chartNumber: "DEMO-1003",
      patientName: "가상 이민호",
      sexAtBirth: "male",
      dateOfBirth: "1982-09-20",
      reason: "요추부 통증",
      receptionStatus: "called",
      encounterStatus: "in_progress",
      flowStage: "testing",
      arrivedAt: "2026-08-01T06:45:00.000Z",
    },
    {
      receptionId: "reception-demo-post-test",
      encounterId: "encounter-demo-post-test",
      patientId: "patient-demo-post-test",
      chartNumber: "DEMO-1004",
      patientName: "가상 최유진",
      sexAtBirth: "female",
      dateOfBirth: "1963-12-02",
      reason: "우측 고관절 통증",
      receptionStatus: "called",
      encounterStatus: "in_progress",
      flowStage: "post_test",
      arrivedAt: "2026-08-01T06:50:00.000Z",
    },
    {
      receptionId: "reception-demo-on-hold",
      encounterId: "encounter-demo-on-hold",
      patientId: "patient-demo-on-hold",
      chartNumber: "DEMO-1005",
      patientName: "가상 정우진",
      sexAtBirth: "male",
      dateOfBirth: "1990-06-18",
      reason: "우측 손목 통증",
      receptionStatus: "waiting",
      encounterStatus: "planned",
      flowStage: "on_hold",
      arrivedAt: "2026-08-01T06:55:00.000Z",
    },
  ],
};
